import { Controller } from "@hotwired/stimulus"
import * as Credential from "src/credential";
import { showMessage } from "src/messenger";

export default class extends Controller {

  async submit(event) {
    event.preventDefault()

    const form = this.element
    const formData = new FormData(form)

    try {
      const response = await fetch(form.action, {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
        },
        body: formData
      })

      const data = await response.json()

      if (response.ok) {
        // WebAuthn start
        if (data.user) {
          await Credential.create(data)
        }
      } else {
        this.handleError(data)
      }

    } catch (error) {
      console.error(error)
      showMessage(["Network error"])
    }
  }

  handleError(data) {
    if (!data.errors) {
      showMessage(["Unknown error"])
      return
    }

    const input = document.querySelector('input[name="registration[email]"]')
    input.classList.add("is-invalid")

    let message = input.parentElement.querySelector(".invalid-feedback")

    if (!message) {
      message = document.createElement("div")
      message.classList.add("invalid-feedback")
      input.after(message)
    }

    message.innerHTML = data.errors[0]
  }

}
